<template>
  <div id="app" :style="minWidth">  <!--min-width 1024 + navbar 256px-->
    <header-menu v-if="logined"></header-menu>
    <router-view v-else></router-view>
    <update-notification
      v-if="!isPublicPage"
      :show="newVersion"
      @update="refresh"
      @dismiss="dismissUpdate"
    />
  </div>
</template>

<script>
import { destroyObjectProperties } from 'highcharts'
import firebase from "firebase/app";
import "firebase/database";
import UpdateNotification from './components/UpdateNotification.vue'
export default {
  name: 'app',
  components: {
    'header-menu': require('./components/main/header').default,
    'update-notification': UpdateNotification,
  },
  watch: {
    $route (to, from){
      const noRedirect = [
        "relationship-mapping",
        "reward-message",
        "user-registration",
        "login",
        "pincode",
        "relationship-mapping",
        "setup-wizard",
        "signup-entry",
        "signup-verify",
        "signup-wizard"
      ]
      let changeRule = noRedirect.includes(to.name);
      if (this.sideBarStatus == false && !changeRule) {
        this.$router.go(this.$router.currentRoute);
      }
    },
    // Watch for account switching state (shows HTML overlay before reload)
    '$store.state.accountSwitcher.isSwitching': function(newVal) {
      if (newVal) {
        // Show the HTML overlay (from index.html) - persists through reload
        const overlay = document.getElementById('account-switch-overlay');
        const companyEl = document.getElementById('switch-company-name');
        const companyName = this.$store.state.accountSwitcher.switchingToCompany || 'new account';

        if (overlay && companyEl) {
          companyEl.textContent = companyName;
          overlay.style.display = 'flex';
        }
      } else {
        // Switch failed or was cancelled - hide the overlay
        this.hideHtmlOverlay();
      }
    },
  },
  data () {
    return {
      sideBarStatus: false,
      pagesIgnoreSidebar: {
        "/relationship-mapping": true,
        "/reward-message": true,
        "/user-registration": true,
        "/login": true,
        "/pincode": true,
        "/sso-login": true,
        "/sso-logout": true,
        "/sso-mobile": true,
        "/signup": true,
        "/signup/verify": true,
      },
      pagesMinWidht: {
        "/relationship-mapping": "450px",
        "/reward-message": "auto",
        "/user-registration": "auto",
        "/login": "auto",
        "/pincode": "auto",
        "/sso-login": "auto",
        "/sso-logout": "auto",
        "/sso-mobile": "auto",
        "/signup": "auto",
        "/signup/verify": "auto",
        "/billing": "auto",
      },
      newVersion: false,
    }
  },
  beforeCreate(){
    this.$store.commit('demomode/initialiseBlur');
  },
  created () {
    this.$store.dispatch('authen/setUserLogin')
    // Initialize account switcher (restores cached accounts from localStorage)
    this.$store.dispatch('accountSwitcher/initialize')
    
    // Check if we're coming from an account switch
    this.checkAccountSwitchState()
  },
  computed: {
    /**
     * Path used for shell decisions. Touches `$route` so the computed re-runs
     * on SPA navigations, but falls back to `window.location.pathname` for
     * the first frame: at component-create time Vue Router's `$route` is the
     * START route (`path: '/'`) until navigation resolves, which previously
     * caused the authed shell to flash for one frame on a hard refresh of
     * `/signup/...` while a cached auth session existed.
     */
    currentPath () {
      const routePath = this.$route ? this.$route.path : '/'
      if (routePath && routePath !== '/') return routePath
      if (typeof window !== 'undefined' && window.location && window.location.pathname) {
        return window.location.pathname
      }
      return routePath
    },
    isPublicPage () {
      const path = this.currentPath
      return Boolean(this.pagesIgnoreSidebar[path]) || this.isSignupRoute(path)
    },
    logined () {
      if (this.isPublicPage) {
        this.sideBarStatus = false
        return false
      }

      const userLoged = this.$store.getters['authen/checkLogin']
      if (userLoged) {
        this.$store.dispatch('main/getuser')
        this.$store.dispatch('main/getteam')
      }
      this.sideBarStatus = true
      return userLoged
    },
    minWidth () {
      const currentPate = this.currentPath
      if (this.pagesMinWidht[currentPate]) {
        return `min-width: ${this.pagesMinWidht[currentPate]};`
      }
      if (this.isSignupRoute(currentPate)) {
        return `min-width: auto;`
      }
      return `min-width: 1024px;`
    },
  },
  mounted() {
    this.checkingVersion()
  },
  methods: {
    /**
     * The signup flow is full-screen pre-auth chrome — bypass the
     * authenticated app shell (sidebar, header) for /signup and any
     * /signup/wizard/:slug path (e.g. /signup/wizard/company). Exact
     * paths /signup and /signup/verify are also covered by
     * pagesIgnoreSidebar; this catches the dynamic wizard step segments
     * cleanly.
     */
    isSignupRoute(path) {
      if (!path || typeof path !== 'string') return false
      return path === '/signup' || path.indexOf('/signup/') === 0
    },
    checkAccountSwitchState() {
      // Check if we're coming from an account switch
      const switchData = localStorage.getItem('accountSwitchInProgress');
      if (switchData) {
        try {
          // Clear the flag
          localStorage.removeItem('accountSwitchInProgress');
          
          // Fade out the HTML overlay after page is ready
          setTimeout(() => {
            this.hideHtmlOverlay();
          }, 500);
        } catch (e) {
          localStorage.removeItem('accountSwitchInProgress');
          this.hideHtmlOverlay();
        }
      }
    },
    
    hideHtmlOverlay() {
      // Fade out and remove the HTML-based overlay from index.html
      const overlay = document.getElementById('account-switch-overlay');
      if (overlay) {
        overlay.classList.add('fade-out');
        setTimeout(() => {
          overlay.style.display = 'none';
          overlay.classList.remove('fade-out');
        }, 300);
      }
    },
    
    checkingVersion() {
      // Use window.location.pathname directly: in mounted() the router may
      // not have resolved yet, so $router.currentRoute.path can still be '/'
      // and the version-popup gate would silently leak onto /signup.
      const currentPate = (typeof window !== 'undefined' && window.location && window.location.pathname)
        ? window.location.pathname
        : this.$router.currentRoute.path
      const onPublicPage = this.pagesIgnoreSidebar[currentPate] || this.isSignupRoute(currentPate)
      if (onPublicPage || currentPate === '/pincode') {
        this.newVersion = false
        return
      }
      firebase.database().ref(`version/my_version`).once("value", snapshot => {
        if (snapshot.val()) {
          localStorage.appVersion = snapshot.val()
        }
        if (localStorage.userVersion != localStorage.appVersion) {
          this.newVersion = true
        }
      })
    },
    dismissUpdate() {
      this.newVersion = false;
    },
    refresh() {
      localStorage.userVersion = localStorage.appVersion
      location.reload(true);
    }
  }
}
</script>
